@if (listIsSplit) {
  <h3>{{requiredHeading}}</h3>
}

@if (requiredList.length > 0) {
  <ol [class.numbered-list]="numbered">
    @for (option of requiredList; track option) {
      <li>
        <app-check-item [model]="option" (changed)="onChange()" [highlightOnChecked]="highlightOnChecked"></app-check-item>
      </li>
    }
  </ol>
}

@if (listIsSplit) {
  <h3>{{optionalHeading}}</h3>
}

@if (optionalList.length > 0) {
  <ol
    [class.numbered-list]="numbered"
    [class.continue-numbering]="numbered"
    [attr.start]="listIsSplit ? requiredList.length : null">
    @for (option of optionalList; track option) {
      <li>
        <app-check-item [model]="option" (changed)="onChange()" [highlightOnChecked]="highlightOnChecked"></app-check-item>
      </li>
    }
  </ol>
}
